import { Box, Button, ListItemIcon, makeStyles, Typography } from '@material-ui/core';
import { ArrowLeft, Close } from '@material-ui/icons';
import React from 'react';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  container: {
    position: 'fixed',
    top: '-8px',
    width: '100%',
    height: '100%',
  },
  subContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%',
  },
  icon: {
    fontSize: 160,
    color: 'red',
    marginBottom: 16,
  },
  title: {
    fontSize: '40px',
    fontWeight: 400,
    marginBottom: 8,
  },
  description: {
    fontSize: 16,
    color: '#666666',
  },
}));

export const NotFound: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Box className={classes.container}>
      <Box className={classes.subContainer}>
        <ListItemIcon>
          <Close className={classes.icon} />
        </ListItemIcon>
        <Typography className={classes.title}>404 PAGE NOT FOUND</Typography>
        <Typography className={classes.description}>This page isn&apos;t available. Sorry about that.</Typography>
        <Typography className={classes.description}>Try searching for something else.</Typography>
        <Button
          variant="contained"
          color="secondary"
          size={'large'}
          startIcon={<ArrowLeft />}
          onClick={() => history.push('/')}
          style={{ marginTop: 32 }}
        >
          <Typography>Back To Top</Typography>
        </Button>
      </Box>
    </Box>
  );
};
